<template>
    <div>
        <slot>

        </slot>
        <div v-if="success" id="successMsg">{{ msg }}</div>
        <div v-else-if="failure">Whoopsie...that didn't work. Are you <a href="/login/">logged in</a>?</div>
        <div><input type="button" value="Add" text="Add" @click="submitForm()" /></div>
    </div>

</template>

<script>
import axios from "axios"

export default {
    name: 'AddTrip',
    data() {
        return {
            msg: '',
            success: false,
            failure: false,
        }
    },
    props: {
        entryId: {
            type: String,
            require: true,
        },
    },
    mounted() {
        //this.msg = this.entryId
    },
    methods: {
        submitForm() {
            this.success = false
            this.failure = false
            let tripId=document.getElementById('tripList').value
            let tUrl="/actions/avgeek-module/default/add-to-trip/?t=" + tripId + "&a=" + this.entryId
            console.log (tUrl)
            axios.get(tUrl).then((r) => {
                    console.log (r.data)
                    let rMsg = r.data
                    if (rMsg.indexOf("<") > -1) {
                        rMsg = rMsg.substring(0,rMsg.indexOf("<"))
                        this.msg = rMsg
                        this.success = true
                        console.log(this.msg)
                        console.log(this.success)
                    } else if (rMsg.indexOf("Trip")>-1) {
                        this.msg = rMsg
                        this.success = true
                        console.log(this.msg)
                        console.log(this.success)
                    } else {
                        this.msg = rMsg
                        this.failure = true
                        console.log(this.msg)
                        console.log(this.failure)
                    }
                    if (r.data === undefined ) {
                        //this.msg=('Whoopsie...that didn\'t work.')
                        this.failure = true
                    }
                }).catch((error) => {
                    //console.log(error.response)
                    //this.msg=('Whoopsie...that didn\'t work. Are you <a href="/login/">logged in</a>?')
                    this.failure = true
                })
            return true
        }
    }
}

</script>